var _circle, _g, _path, _circle2, _circle3, _circle4, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialImpact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 365,
    viewBox: "0 0 365 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 179,
    r: 169,
    fill: "#FF0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1983_246)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 182.556,
    cy: 178.555,
    r: 132.087,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.406 213.468L182.555 133.733L234.705 213.468H130.406Z",
    stroke: "#FF0000",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.555,
    cy: 118.961,
    r: 31.0763,
    fill: "white",
    stroke: "#FF0000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.744,
    cy: 218.582,
    r: 31.0763,
    fill: "white",
    stroke: "#FF0000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.261,
    cy: 218.582,
    r: 31.0763,
    fill: "white",
    stroke: "#FF0000"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1983_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.304 99.8369C179.373 99.8368 175.531 101.002 172.263 103.186C168.996 105.369 166.449 108.473 164.944 112.104C163.44 115.735 163.047 119.73 163.813 123.585C164.58 127.44 166.473 130.98 169.252 133.76C172.031 136.539 175.572 138.431 179.426 139.198C183.281 139.965 187.277 139.571 190.908 138.067C194.539 136.563 197.642 134.016 199.826 130.749C202.009 127.481 203.175 123.639 203.175 119.708C203.173 114.439 201.078 109.386 197.352 105.66C193.626 101.934 188.573 99.8393 183.304 99.8369ZM183.304 105.798C184.483 105.798 185.635 106.148 186.615 106.803C187.596 107.458 188.36 108.389 188.811 109.479C189.262 110.568 189.38 111.766 189.15 112.923C188.92 114.079 188.352 115.141 187.518 115.975C186.685 116.809 185.622 117.376 184.466 117.606C183.31 117.836 182.111 117.718 181.022 117.267C179.933 116.816 179.002 116.052 178.347 115.071C177.691 114.091 177.342 112.939 177.342 111.76C177.341 110.976 177.494 110.201 177.794 109.477C178.093 108.753 178.532 108.096 179.086 107.542C179.64 106.988 180.297 106.549 181.021 106.25C181.745 105.951 182.52 105.797 183.304 105.798ZM183.304 134.015C180.943 134.015 178.618 133.431 176.538 132.314C174.458 131.197 172.686 129.583 171.381 127.616C171.44 123.661 179.329 121.495 183.304 121.495C187.258 121.495 195.167 123.661 195.226 127.616C193.921 129.583 192.15 131.197 190.069 132.313C187.989 133.43 185.665 134.014 183.304 134.014V134.015Z",
    fill: "#F60204"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1983_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.715 199.458C127.785 199.458 123.943 200.623 120.675 202.807C117.407 204.99 114.86 208.094 113.356 211.725C111.851 215.356 111.458 219.351 112.225 223.206C112.991 227.061 114.884 230.601 117.663 233.381C120.442 236.16 123.983 238.052 127.837 238.819C131.692 239.586 135.688 239.192 139.319 237.688C142.95 236.184 146.053 233.637 148.237 230.37C150.42 227.102 151.586 223.26 151.586 219.329C151.584 214.06 149.489 209.007 145.763 205.281C142.037 201.555 136.984 199.46 131.715 199.458ZM131.715 205.419C132.894 205.419 134.046 205.769 135.027 206.424C136.007 207.079 136.771 208.01 137.222 209.1C137.673 210.189 137.791 211.387 137.561 212.544C137.331 213.7 136.763 214.762 135.929 215.596C135.096 216.43 134.034 216.997 132.877 217.227C131.721 217.457 130.522 217.339 129.433 216.888C128.344 216.437 127.413 215.673 126.758 214.692C126.103 213.712 125.753 212.56 125.753 211.381C125.752 210.597 125.906 209.822 126.205 209.098C126.504 208.374 126.943 207.717 127.497 207.163C128.051 206.609 128.708 206.17 129.432 205.871C130.156 205.572 130.932 205.418 131.715 205.419ZM131.715 233.636C129.354 233.636 127.029 233.052 124.949 231.935C122.869 230.818 121.097 229.204 119.792 227.237C119.852 223.282 127.741 221.116 131.715 221.116C135.669 221.116 143.578 223.282 143.637 227.237C142.332 229.204 140.561 230.818 138.48 231.934C136.4 233.051 134.076 233.635 131.715 233.635V233.636Z",
    fill: "#F60204"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1983_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.12 199.458C237.19 199.458 233.348 200.623 230.08 202.807C226.812 204.99 224.265 208.094 222.761 211.725C221.257 215.356 220.863 219.351 221.63 223.206C222.397 227.061 224.289 230.601 227.068 233.381C229.847 236.16 233.388 238.052 237.243 238.819C241.097 239.586 245.093 239.192 248.724 237.688C252.355 236.184 255.459 233.637 257.642 230.37C259.826 227.102 260.991 223.26 260.991 219.329C260.989 214.06 258.895 209.007 255.169 205.281C251.443 201.555 246.39 199.46 241.12 199.458ZM241.12 205.419C242.299 205.419 243.452 205.769 244.432 206.424C245.412 207.079 246.176 208.01 246.627 209.1C247.078 210.189 247.196 211.387 246.966 212.544C246.736 213.7 246.168 214.762 245.335 215.596C244.501 216.43 243.439 216.997 242.282 217.227C241.126 217.457 239.927 217.339 238.838 216.888C237.749 216.437 236.818 215.673 236.163 214.692C235.508 213.712 235.158 212.56 235.158 211.381C235.157 210.597 235.311 209.822 235.61 209.098C235.909 208.374 236.348 207.717 236.902 207.163C237.456 206.609 238.114 206.17 238.837 205.871C239.561 205.572 240.337 205.418 241.12 205.419ZM241.12 233.636C238.759 233.636 236.435 233.052 234.354 231.935C232.274 230.818 230.502 229.204 229.197 227.237C229.257 223.282 237.146 221.116 241.12 221.116C245.074 221.116 252.983 223.282 253.043 227.237C251.738 229.204 249.966 230.818 247.886 231.934C245.805 233.051 243.481 233.635 241.12 233.635V233.636Z",
    fill: "#F60204"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1983_246",
    x: 0.46875,
    y: 0.468445,
    width: 364.174,
    height: 364.174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1983_246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1983_246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1983_246",
    x: 157.432,
    y: 96.8369,
    width: 51.7432,
    height: 51.7432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1983_246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1983_246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1983_246",
    x: 105.843,
    y: 196.458,
    width: 51.7432,
    height: 51.7432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1983_246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1983_246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1983_246",
    x: 215.248,
    y: 196.458,
    width: 51.7432,
    height: 51.7432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1983_246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1983_246",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialImpact);
export default __webpack_public_path__ + "static/media/social_impact.3b147b175e8607509b6ab1adb4758773.svg";
export { ForwardRef as ReactComponent };